// extracted by mini-css-extract-plugin
export default {"container":"xC-z"};